import useMessageStore from '@/store/messageStore';
import { localMemory } from 'localmemory';
import { useCountDown } from 'ahooks';
import useUserStore from '@/store/userStore';

export const useTipsFlags = () => {
  const messageStore = useMessageStore();
  const userStore = useUserStore();

  const [targetDate, setTargetDate] = useState<number>();
  const [isTimeout, setIsTimeout] = useState(false);
  const [countTime, setCountTime] = useState(0);

  useEffect(() => {
    setTargetDate(undefined);

    // No reply countdown configured
    if (!userStore.userReplyCountdown) {
      setIsTimeout(false);
      return;
    }

    const latestMsgItem = messageStore.messageList[messageStore.messageList.length - 1];

    // 如果最后一条消息不是客服的消息
    if (
      !latestMsgItem ||
      latestMsgItem?.senderUid === '' ||
      latestMsgItem?.senderUid === userStore.sessionConfig.uid
    ) {
      setIsTimeout(false);
      return;
    }

    // 最后一条消息是客服的消息，则准备倒计时
    const now = Date.now();
    // 已经过了n秒
    const diffSecond = (now - +latestMsgItem.sendTime) / 1000;
    // 后台配置的多少秒超时
    const settingSecond = userStore.userReplyCountdown * 60;

    const countDownTime = settingSecond - diffSecond;
    setTargetDate(now + countDownTime * 1000);
  }, [messageStore.messageList]);

  const [countdown] = useCountDown({
    targetDate: targetDate,
    onEnd: () => {
      setIsTimeout(true);
    },
  });

  return {
    isTimeout,
    setIsTimeout,
    countTime,
  };
};
